<template>
  <div>

    <mdc-dialog class="wide-modal"
                v-model="isOpen"
                :title=title
                :accept="'protocol.buttons.save_session' | trans"
                :cancel="'dro.cancel' | trans"
                @cancel="close"
                @close="close"
                :accept-disabled="isPreviousDateSession && showDatePrevious"
                @validate="saveSession">
      <div class="close-cross" @click="close()" v-if="!isMobile">
        <mdc-icon icon="close"></mdc-icon>
      </div>



      <div class="row"  v-if="!showMands">
        <loader  v-if="!loaded" class="table-loader"></loader>

        <div class="mt-3 col-lg-3 col-md-4 link-stage"  v-for="stage in stagesList" v-if="!stage.isClosed">
          <mdc-button class="link-stage__button" :class="{'disabled': stage.isClosed}" raised
                      @click.prevent="chooseStage(stage.id)">
            <h4 class="link-stage__title">{{stage.description}}</h4>
          </mdc-button>
        </div>

      </div>

      <form novalidate v-if="showMands">
        <div class="wizard-tab-container">

          <loader  v-if="!loaded" class="table-loader"></loader>
          <div class="alert alert-secondary">
            <h4 class="row-title">{{'protocol.buttons.addMandReaction' | trans}}</h4>
            <div class="row">
              <div class="col-10 col-md-11">
                <mdc-textfield type="text"
                               :label="'protocol.buttons.addMandReaction' | trans"
                               name="addMandReactionsItem"
                               :class="{'is-invalid': errors.has('addMandReactionsItem')}"
                               v-validate="'required|max:1000'"
                               v-model="addMandReactionsItem"
                               data-vv-validate-on="none"
                               :data-vv-as="'protocol.buttons.addMandReaction' | trans"/>
                <span class="invalid-feedback"
                      v-if="errors.has('addMandReactionsItem')">
                            <strong>{{ errors.first('addMandReactionsItem') }}</strong>
                        </span>

              </div>
              <div class="col-2 col-md-1">
                <button type="button"
                        class="btn btn-sm btn-rounded btn-add-grey"
                        @click.prevent="addMands(addMandReactionsItem)">
                  <i class="material-icons button-primary btn-fixed">add</i>
                </button>
              </div>
            </div>
          </div>

          <div class="row mt-2 mb-3" v-if="isPreviousDateSession && showDatePrevious" ref="maxTotalAtemptsCountError" id="maxTotalAtemptsCountError">
            <div class="col-12">
              <div class="alert-danger text-center">
                {{'protocol.enter_session_date' | trans}} <strong>{{minDate | toLocaleDateTime}}</strong>
              </div>
            </div>
          </div>

          <table class="table table-sm table-fixed mt-2" v-if="!isMobile && loaded">
            <thead class="thead-light">
            <tr>
              <th>{{'protocol.stimuluses' | trans}}</th>
              <th>{{'protocol.attempts' | trans}}</th>
              <th>{{'protocol.result' | trans}}</th>
            </tr>
            </thead>
            <tbody class="gray-700">
            <tr  v-for="(mand,index) in mands" :key="mand.globalUuid">
              <td>{{mand.description}}</td>
              <td>{{mand.attempt}}</td>
              <td>
                <div
                    class="mdc-radio-wrapper mdc-form-field stimul-radio-wrapper"
                    v-for="(label, key) in mand.recordedReactions">
                  <div
                      class="mdc-radio mdc-ripple-upgraded mdc-ripple-upgraded--unbounded">
                    <input :id="'id'+index + mand.globalUuid +key"
                           type="radio" class="mdc-radio__native-control"
                           v-model="mand.answer"
                           :name="'radios'+index + mand.globalUuid"
                           :key="label.title"
                           :value="label.title"
                           v-on:change="attemptChange(label.id, mand, label.title)">
                    <div class="mdc-radio__background"
                         :style="{background: label.color}">
                      <div class="mdc-radio__outer-circle"></div>
                      <div class="mdc-radio__inner-circle"></div>
                      <label :for="'id'+index + mand.globalUuid + key">{{label.title}}</label>
                    </div>
                  </div>
                </div>
                <button type="button"
                        class="btn return-btn"
                        :disabled="!mand.attempt"
                        @click.prevent="backToPreviousAttempt(mand.globalUuid)">
                  <i class="material-icons mdc-button__icon">undo</i>
                </button>
              </td>
            </tr>
            </tbody>
          </table>

          <div class="mobile-table position-relative mt-3" v-if="isMobile && loaded">

            <div class="mobile-table__head">
              <div class="cell">{{'protocol.stimuluses' | trans}}</div>
              <div class="cell">{{'protocol.attempts' | trans}}</div>
            </div>

            <div class="mobile-table__body">
              <div class="mobile-table__row"
                   v-for="(mand,index) in mands" :key="mand.globalUuid">

                <div class="container-load" v-if="mand.answer">
                  <svg viewbox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" :class="{'animate': mand.answer}">
                    <path d="M 18 32.34 l -8.34 -8.34 -2.83 2.83 11.17 11.17 24 -24 -2.83 -2.83 z" stroke="#3da35a" fill="transparent"/>
                  </svg>
                </div>

                <div>
                  <div class="cell">{{mand.description}}</div>
                  <div class="cell">{{mand.attempt}}</div>
                </div>

                <div class="mt-2 stimul-row"
                     :class="{'stimul-row-3' : (mands.length/3) == 0}">
                  <div
                      class="mdc-radio-wrapper mdc-form-field stimul-radio-wrapper"
                      v-for="(label, key) in mand.recordedReactions">
                    <div
                        class="mdc-radio mdc-ripple-upgraded mdc-ripple-upgraded--unbounded">
                      <input :id="'id'+index + mand.globalUuid +key"
                             type="radio" class="mdc-radio__native-control"
                             v-model="mand.answer"
                             :name="'radios'+index + mand.globalUuid"
                             :key="label.title"
                             :value="label.title"
                             v-on:change="attemptChange(label.id, mand, label.title)">
                      <div class="mdc-radio__background"
                           :style="{background: label.color}">
                        <div class="mdc-radio__outer-circle"></div>
                        <div class="mdc-radio__inner-circle"></div>
                        <label :for="'id'+index + mand.globalUuid + key">{{label.title}}</label>
                      </div>
                    </div>
                  </div>
                  <button type="button"
                          class="btn return-btn"
                          :disabled="!(mand.lastAnswers ? mand.lastAnswers.length : false)"
                          @click.prevent="backToPreviousAttempt(mand.globalUuid)">
                    <i class="material-icons mdc-button__icon">undo</i>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="alert alert-warning" v-if="maxTotalAtemptsCountError">
            {{'protocol.max_count_for_session' | trans}}
          </div>
        </div>
      </form>
    </mdc-dialog>
  </div>


</template>

<script>

  import {mapActions, mapGetters, mapState} from 'vuex';
  import Loader from '../../loader/components/Loader';
  import axios from 'axios';
  import cloneDeep from 'lodash/cloneDeep';
  import filter from 'lodash/filter';
  import map from 'lodash/map';
  import sortBy from 'lodash/sortBy';
  import fill from 'lodash/fill';
  import toInteger from 'lodash/toInteger';
  import forIn from 'lodash/forIn';
  import UuidGenerator from '@/common/uuid/UuidGenerator';
  import trim from 'lodash/trim';
  import lang from '../../../lang/translator';
  import moment from 'moment';
  import Constants from '../../undesirableBehavior/Constants';

  export default {
    name: 'protocolMandModal',
    props: {
      'visible': {
        type: Boolean,
        default() {
          return false;
        },
      },
      'protocolId': {
        type: [Number, String],
        default() {
          return null;
        },
      },
      'clientData': {
        type: [Array, Object],
        default() {
          return null;
        },
      },
      'clientId': {
        type: [Number, String],
        default() {
          return null;
        },
      },
    },
    data() {
      return {
        addMandReactionsItem: null,
        disabled: false,
        modalView: true,
        apiUrl: '/protocols/assigned/mand/',
        loaded: false,
        showMands: false,
        mands: [],
        timerId: null,
        totalAtemptsCount: 0,
        maxTotalAtemptsCountError: false,
        maxTotalAtemptsCount: 3000,
        newMands: [],
        title: '',
        stagesList: [],
        currentStage: null,
        protocolData: null
      };
    },
    components: {
      Loader,
    },
    methods: {
      close() {
        this.$emit('close');
      },

      chooseStage: async function(stageId) {
        try {
          let response = await axios.get(this.apiUrl + this.protocolId + '/show-stage/' + stageId);

          let protocol = response.data.data;

          this.title = lang.get('protocol.title_mand_reaction') + ': ' + this.protocol.shortcutMenuTitle + ' - ' + protocol.description;


          this.currentStage = protocol;
          let mandList = cloneDeep(protocol.globalTasks);

          this.mands = map(protocol.mands, (mand) => {

            let currentMand = filter(mandList, function(item) {
              return item.uuid == mand.globalUuid;
            });

            if (currentMand.length == 1){

              mand.attempt = 0;
              mand.attepmtsCount = '1';
              mand.description = currentMand[0].description;
              let lastAnswers = mand.lastAnswers ? mand.lastAnswers : [];
              this.$set(mand, 'lastAnswers', lastAnswers);
              let lastAnswersCount = mand.lastAnswersCount ? mand.lastAnswersCount : [];
              this.$set(mand, 'lastAnswersCount', lastAnswersCount);
              this.$set(mand, 'answers', []);
              mand.recordedReactions = protocol.recordedReactions;
              delete mand['uuid'];

              return mand;

            }

          });

          this.mands = sortBy(this.mands, 'position');
          this.showMands = true;


        } catch (error) {
          console.dir(error);
        } finally {
          this.loaded = true;
        }
      },

      getProtocols: async function() {
        try {
          let response = await axios.get(this.apiUrl + this.protocolId + '/info');
          this.protocolData = response.data.data;
          this.protocol = response.data.data.protocol;
          this.title = lang.get('protocol.title_mand_reaction') + ': ' + this.protocol.shortcutMenuTitle;
          this.stagesList = this.protocol.stages;

        } catch (error) {
          console.dir(error);
        } finally {
          this.loaded = true;
        }
      },

      attemptChange: function(answer, mand, title) {

        if (this.timerId){
          clearTimeout(this.timerId);
        }

        this.totalAtemptsCount++;
        if (this.totalAtemptsCount <= this.maxTotalAtemptsCount){
          this.maxTotalAtemptsCountError = false;

          forIn(this.mands, item => {
            if (item.globalUuid == mand.globalUuid) {

              item.answers.push(answer);
              item.attempt++;
              item.lastAnswers.push(title);

            }
          });

        } else{
          this.maxTotalAtemptsCountError = true;
          this.totalAtemptsCount--;
          setTimeout(() => {
            this.$refs.maxTotalAtemptsCountError.scrollIntoView();
          }, 100);
        }

        this.disabledSave = false;

        this.timerId = setTimeout(function() {
          mand.answer = null;
        }, 200);

      },


      backToPreviousAttempt: function(id) {


        let mands = cloneDeep(this.mands);

        forIn(mands, (item) => {
          if (item.globalUuid == id) {
            item.answers.pop();
            item.lastAnswers.pop();
            item.attempt--;
            this.totalAtemptsCount--;
          }
        });

        setTimeout(() => {
          this.mands = mands;
        }, 200);

      },

      saveSession: async function() {

        if(this.showMands){
          let isSaved;
          this.loaded = false;
          this.errors.clear();

          let mandReactions = cloneDeep(this.mands);

          mandReactions = map(mandReactions, (mand) => {

            delete mand['recordedReactions'];
            delete mand['lastAnswers'];
            delete mand['lastAnswersCount'];
            return mand;

          });

          let sessionDate, timeSessionDate, timeSessionEndDate;

          if (this.isPreviousDateSession) {
            let clientTimeZoneOffset = moment().tz(this.clientData.timezone)._offset;
            sessionDate = new Date(Date.UTC(this.previousDate.getFullYear(),
                this.previousDate.getMonth(),
                this.previousDate.getDate(),
                this.previousTime.HH,
                this.previousTime.mm));
            timeSessionDate = moment(sessionDate).unix() -
                (Math.abs(clientTimeZoneOffset) * Constants.SECONDS_PER_MINUTE);
            timeSessionEndDate = moment(sessionDate).unix() -
                (Math.abs(clientTimeZoneOffset) * Constants.SECONDS_PER_MINUTE) +
                this.previousDuration * Constants.SECONDS_PER_MINUTE;
          }

          isSaved = axios.post(this.apiUrl + this.protocolId + '/sessions',
              {
                'index': this.currentStage.position,
                'uuid': this.currentStage.uuid,
                'close': false,
                'majorVersion': this.protocol.majorVersion,
                'newMandReactions' : this.newMands,
                'assignedSessions': [
                  {
                    'uuid': UuidGenerator.v4(),
                    'startedAt': this.isPreviousDateSession ?
                        timeSessionDate :
                        (this.currentSesssionDate ?
                            this.currentSesssionDate :
                            Math.round((new Date()).getTime() / 1000)), //
                    'finishedAt': this.isPreviousDateSession ?
                        timeSessionEndDate :
                        Math.round((new Date()).getTime() / 1000),
                    'stimuli': mandReactions,
                    'type': this.currentStage.type
                  },
                ],
              }).then(response => {
            this.close();
          }).catch(error => {
            if (error.response) {
              this.disabled = false;
            }
          });
        } else{
          this.$emit('close');
        }


      },

      addMands: async function(item) {
        let unique = true;

        let result = await this.$validator.validate();

        if (!result) {
          return;
        }

        if (item) {

          forIn(this.currentStage.globalTasks, function(mand) {
            if (trim(mand.description.toLowerCase()) ===
                trim(item.toLowerCase())) {
              unique = false;
            }
          });

          if (unique) {

            let uuid = UuidGenerator.v4();

            this.mands.push({
              attempt: 0,
              sessionAnswers: {},
              globalUuid: uuid,
              description: item,
              title: item,
              answer: null,
              answers: [],
              active: true,
              checked: true,
              recordedReactions: this.mands[0].recordedReactions,
              position: 0,
              lastAnswers: [],
              attepmtsCount: '1',
              lastAnswersCount: []
            });

            this.newMands.push({
              globalUuid: uuid,
              description: item,
            });


            this.addMandReactionsItem = null;
            this.errors.clear();
            this.disabledSave=false;
          } else {
            this.errors.add({
              field: 'addMandReactionsItem',
              msg: lang.get('protocol.unique_mand'),
            });
          }

        } else {
          this.errors.add({
            field: 'addMandReactionsItem',
            msg: lang.get('protocol.mand_required'),
          });
        }
      },

    },


    computed: {
      ...mapGetters('mobile', [
        'isMobile',
      ]),

      isOpen: {
        get() {
          return this.visible;
        },
        set() {
        },
      },

      ...mapGetters('auth', [
        'isPreviousDateSession',
        'previousDate',
        'previousTime',
        'previousDuration'
      ]),

      minDate() {
        return this.protocolData.endDate ? moment(this.protocolData.endDate.date, 'YYYY-MM-DD HH:mm').toDate() : null;
      },

      showDatePrevious() {
        if (this.protocolData && this.protocolData.endDate && this.previousDate && this.previousTime && this.previousTime.HH && this.previousTime.mm){

          let protocolDate = moment(this.protocolData.endDate.date, 'YYYY-MM-DD HH:mm').unix();
          let sessionDate = new Date(Date.UTC(this.previousDate.getFullYear(),
              this.previousDate.getMonth(),
              this.previousDate.getDate(),
              this.previousTime.HH,
              this.previousTime.mm));
          let previous = moment(sessionDate).unix()
          return previous <= protocolDate;

        }

        return true;
      },

    },

    created() {
      this.currentSesssionDate = Math.round((new Date()).getTime() / 1000);

      this.getProtocols();
    }

  };
</script>


// WEBPACK FOOTER //
// src/modules/dashboardModal/components/protocolModal.vue